import React, { useState, useEffect } from "react";
import BookingCreator from "../AllTabs/StudentTabs/BookingCreator";
import StudentBookings from "../AllTabs/StudentTabs/StudentBookings";
import StudentBookingsGrid from "../AllTabs/StudentTabs/StudentBookingsGrid.jsx";
import StudentDetail from "../AllTabs/StudentTabs/StudentDetail";
import StudentInvoice from "../AllTabs/StudentTabs/StudentInvoice";
import StudentPayments from "../AllTabs/StudentTabs/StudentPayments";
import StudentStays from "../AllTabs/StudentTabs/StudentStays"
import StudentSummary from "../AllTabs/StudentTabs/StudentSummary";
import StudentTransfers from "../AllTabs/StudentTabs/StudentTransfers";
import { SERVER_URL } from "../../constants.js";
import '../../styles/Tabs.css';
import { jsonOr } from "../../utils/http";


const StudentTabs = (props) => {

    const { selectedPerson, onClose, selectedYear } = props;
    const [activeTab, setActiveTab] = useState("details");
    const [selectedStay, setSelectedStay] = useState(null);
    const [bookingGroupId, setBookingGroupId] = useState(null);
    // Whether the student's booking group is still being billed as a group.
    // A group can be "broken out" (booking meta deleted) — students then bill individually.
    const [groupBilledAsGroup, setGroupBilledAsGroup] = useState(false);

    useEffect(() => {
        if (!selectedPerson?.id) return;
        const token = sessionStorage.getItem("bearer");
        let cancelled = false;
        fetch(`${SERVER_URL}api/students/${selectedPerson.id}`, {
            headers: { Authorization: `Bearer ${token}` },
        })
            .then((res) => (jsonOr(res, null)))
            .then((data) => {
                if (cancelled) return;
                const gid = data?.bookingGroupId ?? null;
                setBookingGroupId(gid);
                if (!gid) {
                    setGroupBilledAsGroup(false);
                    return;
                }
                // Group exists for this student — check whether it's still being billed as
                // a group. meta.groupBilled === false means the group was broken out for
                // individual billing (meta is preserved). 404 (no meta at all) also means
                // not group-billed.
                fetch(`${SERVER_URL}api/campgroup/${gid}/booking-meta`, {
                    headers: { Authorization: `Bearer ${token}` },
                })
                    .then((res) => (jsonOr(res, null)))
                    .then((meta) => {
                        if (cancelled) return;
                        // Backfilled to true for existing groups; treat missing field as true.
                        setGroupBilledAsGroup(meta != null && meta.groupBilled !== false);
                    })
                    .catch(() => {
                        if (!cancelled) setGroupBilledAsGroup(false);
                    });
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, [selectedPerson?.id]);

    // Gate per-student finance tabs only when the group is still being billed as a group.
    const inBookingGroup = !!bookingGroupId && groupBilledAsGroup;

    const handledetails = () => {
        setActiveTab("details");
    };
    const handlestays = () => {
        setActiveTab("stays");
    };
    const handletransfers = () => {
        setActiveTab("transfers");
    };
    const handlebookings = () => {
        setActiveTab("bookings");
    };
    const handlenewbooker = () => {
        setActiveTab("newbooker");
    };
    const handlebookingcreator = () => {
        setActiveTab("bookingcreator");
    };
    const handlepayments = () => {
        setActiveTab("payments");
    };
    const handleinvoice = () => {
        setActiveTab("invoice");
    };
    const handleSummary = () => {
        setActiveTab("summary");
    };

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    return (
        <div className="Tabs">
            {/* Tab nav */}
            <ul className="nav">
                <li
                    className={activeTab === "details" ? "active" : ""}
                    onClick={handledetails}>
                Details
                </li>
                <li
                    className={activeTab === "stays" ? "active" : ""}
                    onClick={handlestays}>
                Stays
                </li>
                <li
                    className={activeTab === "bookingcreator" ? "active" : ""}
                    onClick={handlebookingcreator}>
                Booker
                </li>
                <li
                    className={activeTab === "newbooker" ? "active" : ""}
                    onClick={handlenewbooker}>
                New Booker
                </li>
                <li
                    className={activeTab === "bookings" ? "active" : ""}
                    onClick={handlebookings}>
                Bookings
                </li>
                <li
                    className={activeTab === "transfers" ? "active" : ""}
                    onClick={handletransfers}>
                Flights
                </li>
                {props.showFinancials && (
                <li
                    className={activeTab === "payments" ? "active" : ""}
                    onClick={handlepayments}
                    title={inBookingGroup ? "Managed at the booking group level" : ""}>
                    Payments
                    </li>
                )}
                {props.showFinancials && (
                <li
                    className={activeTab === "invoice" ? "active" : ""}
                    onClick={handleinvoice}
                    title={inBookingGroup ? "Managed at the booking group level" : ""}>
                    Invoice/Receipt
                </li>
               )}
                <li
                    className={activeTab === "summary" ? "active" : ""}
                    onClick={handleSummary}>
                    Summary
                </li>
               <li
                    className="close-tab"
                    onClick={handleClose}>
                Close
                </li>
            </ul>
            <div className="outlet">
                {activeTab === "details" ? <StudentDetail selectedPerson={selectedPerson} selectedStay={selectedStay} setSelectedStay={setSelectedStay} showFinancials={props.showFinancials} onClose={onClose} /> : null}
                {activeTab === "stays" && <StudentStays selectedPerson={selectedPerson} selectedStay={selectedStay} setSelectedStay={setSelectedStay} />}
                {activeTab === "bookingcreator" && <BookingCreator selectedPerson={selectedPerson} selectedStay={selectedStay} showFinancials={props.showFinancials}/>}
                {activeTab === "bookings" ? <StudentBookings selectedPerson={selectedPerson} showFinancials={props.showFinancials} selectedStay={selectedStay} /> : null}
                {activeTab === "newbooker" && <StudentBookingsGrid studentId={selectedPerson.id} token={sessionStorage.getItem("bearer")} showFinancials={props.showFinancials} selectedYear={selectedYear} />}
                {activeTab === "transfers" ? <StudentTransfers selectedPerson={selectedPerson}/> : null}
                {activeTab === "payments" ? (
                    inBookingGroup ? (
                        <GroupRedirectNotice
                            kind="Payments"
                            bookingGroupId={bookingGroupId}
                        />
                    ) : (
                        <StudentPayments selectedPerson={selectedPerson}/>
                    )
                ) : null}
                {activeTab === "invoice" ? (
                    inBookingGroup ? (
                        <GroupRedirectNotice
                            kind="Invoice"
                            bookingGroupId={bookingGroupId}
                        />
                    ) : (
                        <StudentInvoice selectedPerson={selectedPerson} selectedStay={selectedStay}/>
                    )
                ) : null}
                {activeTab === "summary" ? <StudentSummary selectedPerson={selectedPerson} selectedStay={selectedStay}/> : null}
            </div>
        </div>
  );
};

function GroupRedirectNotice({ kind, bookingGroupId }) {
    return (
        <div className="detail-card" style={{ padding: '20px 0', textAlign: 'center', fontSize: '14px' }}>
            <div style={{ fontWeight: 600, marginBottom: 8 }}>
                {kind} are managed at the group level
            </div>
            <div>
                This student is a member of booking group <strong>#{bookingGroupId}</strong>.
                Open that booking group and use the Finance tab to view and edit
                {kind === "Payments" ? " payments" : " the invoice"}.
            </div>
        </div>
    );
}

export default StudentTabs;
